import styled, { css } from 'styled-components';
import { palette } from './colors';
import { primaryColor } from '../../utils/helpers';
import defaultValidatorFn from '@emotion/is-prop-valid';

const Text = styled.span.withConfig({
    shouldForwardProp: (prop) =>
      defaultValidatorFn(prop)
})`
    font-weight: 400;
    color: ${palette.graphite.heavyMetal};
    padding: 0;
    margin: 0;

    ${(props) =>
        props.center &&
        css`
            text-align: center;
        `}

    ${(props) =>
        props.semiBold &&
        css`
            font-weight: 600;
        `}
    ${(props) =>
        props.bold &&
        css`
            font-weight: 700;
        `}
    ${(props) =>
        props.extraBold &&
        css`
            font-weight: 800;
        `}

    ${(props) =>
        props.underline &&
        css`
            text-decoration: underline;
        `}
    
    ${(props) =>
        props.italic &&
        css`
            font-style: italic;
        `}
    
    ${(props) =>
        props.lighter &&
        css`
            opacity: 0.6;
        `}

    ${(props) =>
        props.color &&
        css`
            color: ${(props) => props.color};
        `}
    
    ${(props) =>
        props.themed &&
        css`
            color: ${(props) => primaryColor(props)};
        `}
    
    ${(props) =>
        props.error &&
        css`
            color: ${palette.vibrant.red};
        `}
    
    ${(props) =>
        props.flex &&
        css`
            display: flex;
            align-items: center;
        `}
    ${(props) =>
        props.gap &&
        css`
            gap: ${props.gap}px;
        `}
    ${(props) =>
        props.padding &&
        css`
            padding: ${props.padding}px;
        `}
    ${(props) =>
        props.margin &&
        css`
            margin: ${props.margin}px;
        `}
    ${(props) =>
        props.my &&
        css`
            margin-top: ${props.my}px;
            margin-bottom: ${props.my}px;
        `}
    ${(props) =>
        props.mx &&
        css`
            margin-left: ${props.mx}px;
            margin-right: ${props.mx}px;
        `}
    ${(props) =>
        props.mt &&
        css`
            margin-top: ${props.mt}px;
        `}

    ${(props) =>
        props.mb &&
        css`
            margin-bottom: ${props.mb}px;
        `}
    ${(props) =>
        props.ml &&
        css`
            margin-left: ${props.ml}px;
        `}
    ${(props) =>
        props.mr &&
        css`
            margin-right: ${props.mr}px;
        `}
    
    ${(props) =>
        props.airy &&
        css`
            margin-right: 4px;
        `}

    ${(props) =>
        props.link &&
        css`
            cursor: pointer;
        `}
    ${(props) =>
        props.uppercase &&
        css`
            text-transform: uppercase;
        `}
    ${(props) =>
        props.cutLongText &&
        css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}

    ${(props) =>
        props.maxLineCount &&
        css`
            display: -webkit-box;
            -webkit-line-clamp: ${props.maxLineCount};
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
    
    ${(props) =>
        props.noWrap &&
        css`
            white-space: nowrap;
        `}
        
    ${(props) =>
        props.maxWidth &&
        css`
            max-width: ${props.maxWidth}px;
        `}
    ${(props) =>
        props.minWidth &&
        css`
            min-width: ${props.minWidth}px;
        `}
    ${(props) =>
        props.minHeight &&
        css`
            min-height: ${props.minHeight}px;
        `}
    ${(props) =>
        props.backgroundColor &&
        css`
            background: ${props.backgroundColor};
        `}
    ${(props) =>
        props.borderRadius &&
        css`
            border-radius: ${props.borderRadius}px;
        `}
    ${(props) =>
        props.desktopOnly &&
        css`
            @media (max-width: 992px) {
                display: none !important;
            }
        `}
    ${(props) =>
        props.mobileOnly &&
        css`
            display: none;
            @media (max-width: 992px) {
                display: initial;
            }
        `}
    ${(props) =>
        props.lineHeight &&
        css`
            line-height: ${props.lineHeight};
        `}}

    ${(props) =>
        props.fontSizeRem &&
        css`
        font-size: ${props.fontSizeRem}rem!important;
        `}}
`;

// Text / Lead
export const TextLead = styled(Text)`
    font-size: 16px;

`;

// Text / Default
export const TextDefault = styled(Text)`
    font-size: 14px;
`;

// Text / Tiny (2nd line, or small widgets)
export const TextTiny = styled(Text)`
    font-size: 13px;
`;

// Text / Label
export const TextLabel = styled(Text)`
    font-size: 11px;
`;
